import axios from 'axios'
import * as _ from 'lodash'

/**
 * 获取所有的WebApp
 * @author chuck
 * @date 2019/1/9
 */
export async function getAllApps() {
    const response = await axios.get('assets/apps.json')
    if (200 === response.status && _.isArray(response.data)) {
        return  response.data
    }

    return []
}
